import { selectCurrentEntitiesDenormalizedByType } from 'ducks/entities/selectors'
import { createBasicSelector } from 'util/redux'

export const selectPlans = createBasicSelector(state =>
  selectCurrentEntitiesDenormalizedByType(state, 'plan')
)
